import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import Login from './Login/Login';

const User = props => {
    const { match } = props;
    return (
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/login`} />
            <Route path={`${match.url}/login`} component={Login} />
        </Switch>
    );
};

export default User;
